import { nextTick, ref, watch } from '@nuxtjs/composition-api';
import { API_URL } from '@/constants/config';
import { init } from './quizUtils';
import { hasQuestion } from '~/modules/article/utils/articleUtils';
import { eventBus } from '~/modules/common/utils/eventBus';

const base = API_URL + '/v3.5';

export const quizResult = ref(false);
export function initQuizResources(article) {
  // if article is not a quiz return empty stuff
  if (!hasQuestion(article)) {
    return { quizScripts: {}, quizResult };
  }

  const jqueryLoaded = ref(false);
  const quizScripts = {
    script: [
      {
        hid: 'jquery',
        src: 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js',
        async: true,
        callback: () => {
          jqueryLoaded.value = true;
          eventBus.emit('load-jquery');
        },
      },
    ],
  };

  watch(jqueryLoaded, async () => {
    if (!jqueryLoaded.value) return;
    await nextTick();
    initQuiz(article, quizResult);
  });

  return {
    quizScripts,
    quizResult,
  };
}

export async function initQuiz(article, shareQuizResult) {
  const storage = await import('./storage.js');
  const mainQuizEl = $('div.main').find('article[data-legacy-id]').last();
  article.$main = mainQuizEl;
  const $main = article.$main;
  const title = article.title;
  const url = article.url;

  // FIXME: Bos geliyor, ['desktop', 'mobile'] olabilir
  const viewScope = article.viewScope;
  /**
   * @info Burasi utilleri initialize etmeye yariyor
   */
  await init({
    article,
    $main,
    url,
    title,
    viewScope,
  });

  /**
    @info Burasi lazim degil, CommentID-1 (Bunun {true} donme ihtimali yok)
   */
  // const multiChoice = typeof articleTags !== 'undefined' ? articleTags.includes('#multichoice-poll') : false;

  if (!$main.find('section.question.entry').length) return;

  const $questionSection = $($main.find('section.question.entry'));
  setTimeout(() => {
    const $answers = $questionSection.find('div.answer');

    /**
   @info: Cevaplara tiklayinca burasi tetikleniyor.
  */
    $answers.on('click tap', function () {
      const completedTests = storage.get('_oi_completedtest') || [];

      if (!completedTests.includes(article.legacyId)) {
        // Firing only 1st answers of quiz questions to Adform
        const localStorageKey = 'question-sent-segments';
        const entrySentSegments = [];
        const entryId = $(this).parents('section.entry.question').data('id');

        if (!entrySentSegments.includes(entryId)) {
          const $segments = $(this).data('segments');

          if ($segments && $segments.length > 0) {
            $segments.forEach(function (segment) {
              const segmentArr = segment.split('|');
              const segmentUrl =
                (segment.indexOf('http') !== 0 ? '//dmp.adform.net/dmp/profile/?pid=10548&sg=' : '') + segmentArr[segmentArr.length - 1];
              $('body').append("<img src='" + segmentUrl + "' style='position:absolute;display:none;'/>");
              // Pass data to IOS webkit
              if (window.webkit && window.webkit.messageHandlers) {
                window.webkit.messageHandlers.callBackHandler.postMessage({
                  sg: segmentArr[segmentArr.length - 1],
                });
              }
              // FIXME: Yeni adform apisi ile acilacak
              // FIXME: URL degisecek
              $.get(`${base}/dmp/segments`, function ({ data }) {
                const segmentObject = data.find((segment) => {
                  if (segment.name === segmentArr[segmentArr.length - 1]) {
                    return true;
                  }
                });
                if (segmentObject) {
                  window.fbq('trackCustom', 'adform/audiencetag', {
                    SegmentID: segmentObject.id,
                    DataProviderID: 10548,
                    RefID: segmentObject.name,
                  });
                }
              });
            });
            entrySentSegments.push(entryId);
            window.localStorage.setItem(localStorageKey, JSON.stringify(entrySentSegments));
          }
        }
      }
    });

    // select all element which contains entry css class
    const $sections = document.querySelectorAll('section.question.entry');
    // create a new set for unique test mode
    const selectors = new Set();
    $sections.forEach((element) => {
      // add data-mode name to selector
      selectors.add(element.querySelector('.answers').getAttribute('data-mode'));
    });

    selectors.forEach(async (element) => {
      // import js file according to data-mode name.
      const { [element]: result } = await import(`./${element}`);
      result(article, shareQuizResult);
    });
  }, 1000);
}
